import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.46 4.898a.7.7 0 0 1 .7-.7h3.14a.7.7 0 0 1 .7.7v10.204a.7.7 0 0 1-.7.7h-3.14a.7.7 0 0 1-.7-.7V4.898Zm1.4.7v8.804h1.74V5.598h-1.74Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M10.399 10.675a.7.7 0 0 1-.037.989l-.346.321h4.144a.7.7 0 1 1 0 1.4h-4.144l.346.322a.7.7 0 1 1-.952 1.026l-1.653-1.535a.7.7 0 0 1 0-1.026l1.653-1.534a.7.7 0 0 1 .989.037ZM9.732 5.286a.7.7 0 0 1 .99-.001l1.538 1.534a.7.7 0 0 1 0 .991l-1.538 1.535a.7.7 0 0 1-.988-.991l.34-.34H6.127a.7.7 0 1 1 0-1.4h3.945l-.34-.338a.7.7 0 0 1 0-.99Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M2 5.013a.7.7 0 0 1 .7-.7h3.069a.7.7 0 0 1 .7.7v9.974a.7.7 0 0 1-.7.7h-3.07a.7.7 0 0 1-.7-.7V5.013Zm1.4.7v8.574h1.669V5.713h-1.67Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
